module.exports = __webpack_public_path__ + "img/img7.dea08bb2.jpg";